"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSmartNumpadKeyDown = handleSmartNumpadKeyDown;
function handleSmartNumpadKeyDown(event, setValue, options = {}) {
    const { commaDecimal = false } = options;
    const numpadMap = {
        Numpad0: '0',
        Numpad1: '1',
        Numpad2: '2',
        Numpad3: '3',
        Numpad4: '4',
        Numpad5: '5',
        Numpad6: '6',
        Numpad7: '7',
        Numpad8: '8',
        Numpad9: '9',
        NumpadDecimal: (commaDecimal ? ',' : '.')
    };
    if (numpadMap[event.code]) {
        event.preventDefault();
        setValue((prev) => prev + numpadMap[event.code]);
    }
}
